import { createAPI } from '@common'
export default {
  // 写稿量
  postStatWorkloadAdd: (config) =>
    createAPI('customEncryptApiName-1/0w20tubu0xpslmpbe0bee', 'POST', config),
  // 被签发量
  postStatWorkloadForward: (config) =>
    createAPI('customEncryptApiName-1/0w20tubu0xpslmpbe0gpsxbse', 'POST', config),
  // 发稿量
  postStatWorkloadPublish: (config) =>
    createAPI('customEncryptApiName-1/0w20tubu0xpslmpbe0qvcmjti', 'POST', config),
  // 单人工作量统计
  postStatWorkload: (config) => createAPI('customEncryptApiName-1/0w20tubu0xpslmpbe', 'POST', config),
  // 部门工作量统计
  postStatWorkloadOrg: (config) =>
    createAPI('customEncryptApiName-1/0w20tubu0xpslmpbe0psh', 'POST', config),
  // 稿件明细统计
  postStatListdata: (config) => createAPI('customEncryptApiName-1/0w20tubu0mjtuebub', 'POST', config),
  // 获取当前统计分值设置
  getStatWorkloadWeight: (config) =>
    createAPI('customEncryptApiName-1/0w20tubu0xpslmpbe0xfjhiu', 'GET', config),
  // 设置统计分值
  postStatWorkloadWeight: (config) =>
    createAPI('customEncryptApiName-1/0w20tubu0xpslmpbe0xfjhiu', 'POST', config),
  // 新-------------------
  // 我的工作量-基础指标统计
  postGetMyWorkload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe', 'POST', config),
  // 我的工作量-稿件明细导出
  downloadMyArticles: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tubu0fyqpsu', 'POST', config),
  // 部门工作量-根据部门获取人员下拉列表
  getUserByOrg: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0f60mjtuebub', 'POST', config),
  // 部门工作量-工作量列表
  getDeptWorkloadTable: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0psh', 'POST', config),
  // 部门工作量-总数统计
  getDeptWorkloadTotal: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0psh0upubm', 'POST', config),
  // 部门工作量-工作量导出
  downloadDeptWorkload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0psh0fyqpsu', 'POST', config),
  // 部门工作量-里-个人工作量导出
  downloadPersonWorkloadInDept: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0psh0bvuips0fyqpsu', 'POST', config),
  // 个人工作量-工作量列表
  getPersonWorkloadTable: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0bvuips', 'POST', config),
  // 个人工作量-总数统计
  getPersonWorkloadTotal: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0bvuips0upubm', 'POST', config),
  // 个人工作量-工作量导出
  downloadPersonWorkload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0bvuips0fyqpsu', 'POST', config),
  // 专题互动数总计-总数统计
  getSpecialArticleTotal: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tubu0hfuTqfdjbmUpubmEbub',
      'POST',
      config
    ),
  // 专题稿件明细列表-稿件明细导出
  downloadSpecialArticles: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tubu0fyqpsu', 'POST', config),
  // 获取工作量统计页面-倍率按钮操作权限
  getE5Actions: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0f60bdujpot', 'get', config, vconfig),
  // 查看app各指标的历史总量
  getTotalStat: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0tubu0upubmTubu', 'GET', config),
  // 获取专题栏目
  getSpecialColumns: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tubu0tqfdjbm0dpmvnot', 'GET', config),
  getE5ListsDefinition: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0f60mjtut0efgjojujpo', 'get', config, vconfig),
  postE5ListsDefinition: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0f60mjtut0efgjojujpo', 'post', config),
  // 稿源库稿件明细导出
  downloadSpecialArticleOrigin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmft0tubu0fyqpsu', 'POST', config),




  // 栏目分析-获取 栏目统计明细 列表，以栏目为维度
  getColumnsWorkloadTable: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0dpmvnot', 'POST', config),
  // 栏目分析-总获取 栏目统计明细 列表总数统计
  getColumnsWorkloadTotal: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0dpmvnot0upubm', 'POST', config),
  // 栏目分析-导出
  downloadColumnsWorkloadInDept: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0dpmvnot0fyqpsu', 'POST', config),


  // 栏目分析-具体某个栏目的-列表
  getColumnWorkloadTable: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0dpmvno', 'POST', config),
  // 栏目分析-具体某个栏目的-导出
  downloadColumnWorkloadInDept: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0dpmvno0fyqpsu', 'POST', config),
  // 栏目分析-具体某个栏目的-列表总数统计
  getColumnWorkloadTotal: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0dpmvno0upubm', 'POST', config),
}